import URI from 'urijs';
export class AjaxHeaderFooter {

  constructor(locale = 'en') {
    let domain;
    switch (locale.toLowerCase()) {
      case 'fr':
        domain = 'fr';
        break;
      case 'fr_be':
        domain = 'be/fr';
        break;
      case 'it':
        domain = 'it';
        break;
      case 'de':
        domain = 'de';
        break;
      case 'es':
        domain = 'es';
        break;
      case 'nl':
        domain = 'be/nl';
        break;
      case 'en':
      default:
        domain = 'co.uk';
        break;
    }
    this.header = `https://www.petit-bateau.${domain}/api/header`;
    this.footer = `https://www.petit-bateau.${domain}/api/footer`;
    this.baseUrl = `https://www.petit-bateau.${domain}`;
    this.headerLoaded = false;
    this.footerLoaded = false;
  }

  async init() {
    // fetch header and footer from client's urls
    const fetchInit = {
      method: 'GET',
      headers: {
        'Accept': 'application/json'
      }
    };

    let headerHTML = '';
    let footerHTML = '';

    try {
      const [headerResult, footerResult] = await Promise.allSettled([
        fetch(this.header, fetchInit),
        fetch(this.footer, fetchInit)
      ]);

      if (headerResult.status === 'fulfilled' && headerResult.value.ok) {
        headerHTML = await headerResult.value.text();
        this.headerLoaded = !!headerHTML.trim();
      }

      if (footerResult.status === 'fulfilled' && footerResult.value.ok) {
        footerHTML = await footerResult.value.text();
        this.footerLoaded = !!footerHTML.trim();
      }

      // add override class when both header and footer are loaded
      const mainContentEl = document.querySelector('.Main-content');
      if (this.headerLoaded && this.footerLoaded && mainContentEl) {
        mainContentEl.classList.add('Main-content--override');
      }

      if (headerHTML.trim()) {
        this.parseResponseAndAddToDOM(headerHTML,'header');
      }
      if (footerHTML.trim()) {
        this.parseResponseAndAddToDOM(footerHTML,'footer');
      }

    } catch (err) {
      console.error('Unexpected error loading header/footer:', err);
    }
  }

  async parseResponseAndAddToDOM(responseHtml,elementType) {
    const parser = new DOMParser();

    /** 
     Normalize all URLs in HTML so they are absolute:
     
     1. If a URL starts with "//" (protocol-relative), prepend the protocol from baseUrl (default: https).
     2. If a URL starts with "/" (root-relative), convert it to a full absolute URL using baseUrl.
     
     This ensures that all resource links are fully qualified and work outside their original site context.
    **/
    let replacedText = responseHtml.replace(
      /"(\/{1,2}[^"<>]*)"/g,
      (str, match1) => {
        // If value starts with "//", prepend protocol from baseUrl or default to "https"
        if (match1.startsWith("//")) {
          const protocol = this.baseUrl
            ? new URI(this.baseUrl).protocol()
            : "https";
          return `"${protocol}:${match1}"`;
        }

        // If value starts with "/", make it absolute to baseUrl
        return `"${new URI(match1).absoluteTo(this.baseUrl || "")}"`;
      }
    );

    const clientDoc = parser.parseFromString(replacedText, 'text/html');
  
    // Move styles from <head> and <body> to document.head
    clientDoc.querySelectorAll('style').forEach((style) => {
      const newStyle = document.createElement('style');
      if (style.id) newStyle.id = style.id;
      newStyle.textContent = style.textContent;
      document.head.appendChild(newStyle);
    });

    clientDoc.querySelectorAll('link[rel="stylesheet"]').forEach((link) => {
      const newLink = document.createElement('link');
      Array.from(link.attributes).forEach((attr) => {
        newLink.setAttribute(attr.name, attr.value);
      });
      document.head.appendChild(newLink);
    });

    // --- Prepare target container ---
    const targetEl = document.body.querySelector(`.js-${elementType}-ajax`);

    // Clone body without scripts
    const bodyClone = clientDoc.body.cloneNode(true);
    const scripts = Array.from(bodyClone.querySelectorAll('script'));
    scripts.forEach((s) => s.remove());

    // Set body attributes and HTML content
    for (let script of clientDoc.querySelectorAll('script')) {
      // wrap in try catch if any error occurs during the script
      try {
        const src = script.getAttribute('src');

        // Skip duplicate external scripts in the same container
        if (src && targetEl.querySelector(`script[src="${src}"]`)) {
          continue;
        }

        const newScript = document.createElement('script');
        for (let attr of script.attributes) {
          newScript.setAttribute(attr.name, attr.value);
        }

        if (script.textContent) {
          // Inline script executes immediately
          newScript.textContent = script.textContent;
          targetEl.appendChild(newScript);
        } else if (src) {
          if (script.hasAttribute('async') || script.hasAttribute('defer')) {
            // Keep async/defer behavior — don’t await
            targetEl.appendChild(newScript);
          } else {
            // No async/defer — block until loaded
            await new Promise((resolve, reject) => {
              newScript.onload = resolve;
              newScript.onerror = reject;
              targetEl.appendChild(newScript);
            });
          }
        }
      } catch (err) {
        console.error('Error running ajax scripts:', err);
      }
    }

    // add dom content to targetEl after scripts and css have been loaded
    targetEl.innerHTML = bodyClone.innerHTML;
  }
}